"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CombinedDataAccess = void 0;
const tslib_1 = require("tslib");
class CombinedDataAccess {
    constructor(reader, writer) {
        this.reader = reader;
        this.writer = writer;
    }
    initialize() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.reader.initialize();
            yield this.writer.initialize();
        });
    }
    close() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.writer.close();
            yield this.reader.close();
        });
    }
    getTransactionsByChannelId(channelId, updatedBetween) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield this.reader.getTransactionsByChannelId(channelId, updatedBetween);
        });
    }
    getChannelsByTopic(topic, updatedBetween) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield this.reader.getChannelsByTopic(topic, updatedBetween);
        });
    }
    getChannelsByMultipleTopics(topics, updatedBetween) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield this.reader.getChannelsByMultipleTopics(topics, updatedBetween);
        });
    }
    persistTransaction(transactionData, channelId, topics) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield this.writer.persistTransaction(transactionData, channelId, topics);
        });
    }
}
exports.CombinedDataAccess = CombinedDataAccess;
